import { useState, useCallback } from "react";

export function useUnsavedChanges(initialState = false) {
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(initialState);

  const markAsDirty = useCallback(() => setHasUnsavedChanges(true), []);
  const resetUnsavedChanges = useCallback(
    () => setHasUnsavedChanges(false),
    [],
  );

  return { hasUnsavedChanges, markAsDirty, resetUnsavedChanges };
}
